var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleplus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Plus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Task",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Task-details",
    transform: "translate(-988.000000, -548.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assignee-row-Copy",
    transform: "translate(396.000000, 530.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatars",
    transform: "translate(552.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plus",
    transform: "translate(40.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 Z M16,1 C7.71572875,1 1,7.71572875 1,16 C1,24.2842712 7.71572875,31 16,31 C24.2842712,31 31,24.2842712 31,16 C31,7.71572875 24.2842712,1 16,1 Z",
    id: "Oval-base",
    fill: "#EAEEF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.55,15.55 L16.45,15.55 L16.45,11.45 C16.45,11.2025 16.2475,11 16,11 C15.7525,11 15.55,11.2025 15.55,11.45 L15.55,15.55 L11.45,15.55 C11.2025,15.55 11,15.7525 11,16 C11,16.2475 11.2025,16.45 11.45,16.45 L15.55,16.45 L15.55,20.55 C15.55,20.7975 15.7525,21 16,21 C16.2475,21 16.45,20.7975 16.45,20.55 L16.45,16.45 L20.55,16.45 C20.7975,16.45 21,16.2475 21,16 C21,15.7525 20.7975,15.55 20.55,15.55 Z",
    id: "Path",
    fill: "#949CAF"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleplus);
export default __webpack_public_path__ + "static/media/circleplus.af299198.svg";
export { ForwardRef as ReactComponent };